<template>
  <!-- 신고하기 -->
  <v-form v-model="valid">
    <v-bottom-sheet
        v-model="sheet"
        scrollable
        persistent
        no-click-animation
        :overlay-opacity="0.7"
        content-class="bottom-sheet"
    >
      <v-card>
        <SheetHeader :title="`${title} 신고하기`" @sheetClose="close()"/>
        <v-card-text>
          <v-layout fill-height column class="form-item">
            <div class="label font-weight-bold">신고 사유</div>
            <div class="input-group">
              <v-select
                  :items="reason"
                  v-model="form.selectedValue"
                  item-value="cd"
                  item-text="cdNm"
                  label="신고 사유를 선택하세요."
                  solo
                  filled
                  single-line
                  background-color="#F7F7F7"
                  :rules="[rules.required]"
              />
            </div>
            <div class="input-group flex-fill">
              <v-textarea
                  v-if="form.selectedValue === '07'"
                  v-model.lazy="form.textValue"
                  solo
                  filled
                  no-resize
                  background-color="#F7F7F7"
                  placeholder="신고 사유를 입력해주세요."
                  counter="500"
                  :rules="[rules.required, rules.trim, rules.length(500)]"
              />
            </div>
          </v-layout>

          <!--        <div class="select-area mb-3">-->
          <!--          <select class="w-full" @change="onChange($event)" :v-model="form.selectedValue">-->
          <!--            <option value="">신고 사유를 선택하세요</option>-->
          <!--            <option v-for="(item, index) in reason" :key="index" :value="item.cd">{{ item.cdNm }}</option>-->
          <!--          </select>-->
          <!--        </div>-->
          <!--        <div class="" style="min-height: 40vh">-->
          <!--          <v-textarea v-model="form.textValue" />-->
          <!--        <Textarea :height="172" v-show="form.textVisible" placeholder="신고 사유를 입력해주세요."-->
          <!--                  :value="form.textValue" @input="inputChanged"/>-->
          <!--        </div>-->
        </v-card-text>
        <v-card-actions>
          <BlackBtn x-large str="신고하기" :isLoading="isLoading" :disabled="isLoading || !valid" @click="setRptReason()"></BlackBtn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </v-form>
</template>
<script>
import store from '@/store'
import SheetHeader from './SheetHeader'
import BlackBtn from '@/components/btns/BlackBtn'
// import Textarea from '@/components/forms/Textarea'

const FORM = () => {
  return {
    setPostNo: null,
    setGb: null,
    setTargetId: null,
    setTargetUserKey: null,
    selectedValue: null,
    textValue: ''
  }
}

export default {
  components: {
    SheetHeader,
    BlackBtn,
    // Textarea
  },
  props: {
    userId: String
  },
  data: () => ({
    title: '신고하기',
    reason: [],
    sheet: false,
    payload: null,
    isLoading: false,
    valid: false,
    form: FORM(),
    rules: {
      required: v => !!v || '필수 값입니다.',
      trim: v => (!!v && v.trim() !== '') || '공백만 작성 할 수 없습니다.',
      length: len => v => (v || '').length <= len || `${len}자 미만으로 작성 할 수 있습니다.`,
    }
  }),
  computed: {
  },
  created () {
    this.getReasonList()
  },
  methods: {
    open (value) {
      console.log("value : ", value)
      this.payload = value
      this.dataSetting(this.payload.item)
      this.sheet = true
    },
    close () {
      this.sheet = false
      this.payload = null
      this.isLoading = false
      this.valid = false
      this.form = FORM()
    },
    dataSetting(value) {
      // console.log("value : ", value)
      if (value.squareNo == null) { // 댓글 신고
        this.title = `댓글`
        this.form.setGb = "02"
        this.form.setPostNo = value.cmntNo
        this.form.setTargetId = value.cmntRegId
        this.form.setTargetUserKey = value.cmntRegUserKey
      } else {
        this.title = `게시글`
        this.form.setGb = "01" // 게시글 신고
        this.form.setPostNo = value.squareNo
        this.form.setTargetId = value.regId
        this.form.setTargetUserKey = value.regUserKey
      }
    },
    async getReasonList() {
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': 'SQ003'}))
          .then(res => {
            if (res.success) {
              this.reason = res.data
            } else {
              console.log(res.msg)
              this.reason = []
            }
          })
          .catch(error => {
            console.error(error)
            this.reason = []
          })
          .finally(() => {
          })
    },
    async setRptReason () {
      let params = {
        postNo: this.form.setPostNo,
        gb: this.form.setGb,
        rptTargetId: this.form.setTargetId,
        rptTargetUserKey: this.form.setTargetUserKey,
        rptReason: this.form.selectedValue,
        rptContent: this.form.textValue.trim(),
        prcStatus: 'N',
        regId: this.userId
      }
      await store.dispatch('setRptReason', this.$_payload('ba', params))
          .then(res => {
            if (res.success) {
              this.$emit('onEvent', {fn: 'menuModalClose'}) // 메뉴 모달 닫기
              this.$alert('신고에 성공하였습니다.')
              this.close()
            } else {
              this.$alert('신고에 실패하였습니다.\n다시 시도해주세요.')
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
          })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .v-dialog:not(.v-dialog--fullscreen) {
    min-height: 80%;
  }
}
</style>
